import { IUrlBuilder } from './urlBuilder.service';

export class UrlBuilderRegistry {
  private builders: { [key: string]: IUrlBuilder} = {};

  public register(key: string, builder: IUrlBuilder) {
    this.builders[key] = builder;
  }

  public getBuilder(key: string): IUrlBuilder {
    return this.builders[key];
  }
}

export const urlBuilderRegistry = new UrlBuilderRegistry();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/navigation/urlBuilder.registry.ts